import _upperCase from "lodash/fp/upperCase";
import { X2yActionType, X2yActionPhase } from "./types";

// eslint-disable-next-line import/prefer-default-export
export const createActionTypeString = (
  description: X2yActionType,
  phase: X2yActionPhase
) => {
  const descOut = _upperCase(description);
  const phaseOut = _upperCase(phase);

  return `ADMINISTRATION > X2Y > ${descOut} > ${phaseOut}`;
};
